module.exports = __webpack_public_path__ + "static/media/img_16.2afc0b6e.png";